import { makeStyles } from 'tss-react/mui';

import {
  LIST_TOP_MARGIN,
  MAX_CONTENT_HEIGHT,
  MAX_MOBILE_CONTENT_HEIGHT,
  SAFE_LIST_AREA_HEIGHT,
  SEARCH_FIELD_BOX_HEIGHT,
  SEARCH_FIELD_BOX_PADDING,
  TABS_HEAIGHT,
} from '../../../styles/constants';

export const useStyles = makeStyles()((theme) => ({
  usersListWrapper: {},
  usersListSearch: {
    marginTop: SEARCH_FIELD_BOX_PADDING,
  },
  narrowScreen: {
    [theme.breakpoints.down('md')]: {
      display: 'flex',
      gap: '4px',
    },
  },
  userBigItemWrapper: {
    marginTop: LIST_TOP_MARGIN,
    borderTop: `1px solid ${theme.palette.paper.borderColor}`,
    maxHeight: `calc(${MAX_CONTENT_HEIGHT} - ${TABS_HEAIGHT} - ${SEARCH_FIELD_BOX_HEIGHT} - ${LIST_TOP_MARGIN} - ${SAFE_LIST_AREA_HEIGHT})`,
    height: `calc(${MAX_CONTENT_HEIGHT} - ${TABS_HEAIGHT} - ${SEARCH_FIELD_BOX_HEIGHT} - ${LIST_TOP_MARGIN} - ${SAFE_LIST_AREA_HEIGHT})`,

    [theme.breakpoints.down('md')]: {
      maxHeight: `calc(${MAX_MOBILE_CONTENT_HEIGHT} - ${TABS_HEAIGHT} - ${SEARCH_FIELD_BOX_HEIGHT} - ${LIST_TOP_MARGIN} - ${SAFE_LIST_AREA_HEIGHT})`,
      height: `calc(${MAX_MOBILE_CONTENT_HEIGHT} - ${TABS_HEAIGHT} - ${SEARCH_FIELD_BOX_HEIGHT} - ${LIST_TOP_MARGIN} - ${SAFE_LIST_AREA_HEIGHT})`,
    },
  },
  userBigItemWrapperWithoutTabs: {
    marginTop: LIST_TOP_MARGIN,
    borderTop: `1px solid ${theme.palette.paper.borderColor}`,
    maxHeight: `calc(${MAX_CONTENT_HEIGHT} - ${SEARCH_FIELD_BOX_HEIGHT} - ${LIST_TOP_MARGIN} - ${SAFE_LIST_AREA_HEIGHT})`,
    height: `calc(${MAX_CONTENT_HEIGHT} - ${SEARCH_FIELD_BOX_HEIGHT} - ${LIST_TOP_MARGIN} - ${SAFE_LIST_AREA_HEIGHT})`,

    [theme.breakpoints.down('md')]: {
      maxHeight: `calc(${MAX_MOBILE_CONTENT_HEIGHT} - ${SEARCH_FIELD_BOX_HEIGHT} - ${LIST_TOP_MARGIN} - ${SAFE_LIST_AREA_HEIGHT})`,
      height: `calc(${MAX_MOBILE_CONTENT_HEIGHT} - ${SEARCH_FIELD_BOX_HEIGHT} - ${LIST_TOP_MARGIN} - ${SAFE_LIST_AREA_HEIGHT})`,
    },
  },
}));
